"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("@stremio/stremio-icons/react"));
var react_2 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var NumberInput_less_1 = __importDefault(require("./NumberInput.less"));
var Button_1 = __importDefault(require("../Button"));
var NumberInput = (0, react_2.forwardRef)(function (_a, ref) {
    var _b, _c;
    var _d;
    var _e = _a.defaultValue, defaultValue = _e === void 0 ? 0 : _e, showButtons = _a.showButtons, onKeyDown = _a.onKeyDown, onSubmit = _a.onSubmit, min = _a.min, max = _a.max, onChange = _a.onChange, props = __rest(_a, ["defaultValue", "showButtons", "onKeyDown", "onSubmit", "min", "max", "onChange"]);
    var _f = (0, react_2.useState)(defaultValue), value = _f[0], setValue = _f[1];
    var displayValue = (_d = props.value) !== null && _d !== void 0 ? _d : value;
    var handleKeyDown = (0, react_2.useCallback)(function (event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (event.key === 'Enter') {
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
        }
    }, [onKeyDown, onSubmit]);
    var handleValueChange = function (newValue) {
        if (props.value === undefined) {
            setValue(newValue);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { value: newValue.toString() } });
    };
    var handleIncrement = function () {
        handleValueChange(clampValueToRange((displayValue || 0) + 1));
    };
    var handleDecrement = function () {
        handleValueChange(clampValueToRange((displayValue || 0) - 1));
    };
    var clampValueToRange = function (value) {
        var minValue = min !== null && min !== void 0 ? min : 0;
        if (value < minValue) {
            return minValue;
        }
        if (max !== undefined && value > max) {
            return max;
        }
        return value;
    };
    var handleInputChange = (0, react_2.useCallback)(function (_a) {
        var valueAsNumber = _a.target.valueAsNumber;
        handleValueChange(clampValueToRange(valueAsNumber || 0));
    }, []);
    return (react_2.default.createElement("div", { className: (0, classnames_1.default)(props.containerClassName, NumberInput_less_1.default['number-input']) },
        showButtons ?
            react_2.default.createElement(Button_1.default, { className: NumberInput_less_1.default['button'], onClick: handleDecrement, disabled: props.disabled || (min !== undefined ? displayValue <= min : false) },
                react_2.default.createElement(react_1.default, { className: NumberInput_less_1.default['icon'], name: 'remove' }))
            : null,
        react_2.default.createElement("div", { className: (0, classnames_1.default)(NumberInput_less_1.default['number-display'], (_b = {}, _b[NumberInput_less_1.default['buttons-container']] = showButtons, _b)) },
            props.label ?
                react_2.default.createElement("div", { className: NumberInput_less_1.default['label'] }, props.label)
                : null,
            react_2.default.createElement("input", __assign({ ref: ref, type: 'number', tabIndex: 0, value: displayValue }, props, { className: (0, classnames_1.default)(props.className, NumberInput_less_1.default['value'], (_c = {}, _c[NumberInput_less_1.default.disabled] = props.disabled, _c)), onChange: handleInputChange, onKeyDown: handleKeyDown }))),
        showButtons ?
            react_2.default.createElement(Button_1.default, { className: NumberInput_less_1.default['button'], onClick: handleIncrement, disabled: props.disabled || (max !== undefined ? displayValue >= max : false) },
                react_2.default.createElement(react_1.default, { className: NumberInput_less_1.default['icon'], name: 'add' }))
            : null));
});
NumberInput.displayName = 'NumberInput';
exports.default = (0, react_2.memo)(NumberInput);
